(function ($) {
	//
	// Default Image Parallax
	//
	$.ZagParallax = function (element, options) {

		options = $.extend({}, $.ZagParallax.defaultOptions, options);

		var Component = element;

		if (Component.children(".zag-parallax-bg").length) {

			Component.addClass("zag-parallax");
			ZagParallaxSet(Component, options.divisor);
			$(function () {
				ZagParallaxSet(Component, options.divisor);
			});
			$(window).on("resize scroll", function () {
				ZagParallaxSet(Component, options.divisor);
			});
		}
	};

	function ZagParallaxSet(Component, divisor) {
		var bg = Component.children(".zag-parallax-bg");
	
        var windowHeight = $(window).innerHeight();
		var imgTop = bg[0].getBoundingClientRect().top;
		var imgBottom = bg[0].getBoundingClientRect().top + bg[0].offsetHeight;

		if (imgTop != imgBottom && imgTop <= windowHeight && imgBottom >= 0) { //if image is visible and on screen

			// parallax coverage is different for components that appear above vs. below the fold
			// if bottom of component is above the fold...
			var bgScale = Component.offset().top + Component.outerHeight() < $(window).height() ? Component.offset().top : $(window).height() - Component.outerHeight();
			var bgHeight = Component.outerHeight() + bgScale / Math.abs(divisor);
			var bgTop = ($(window).scrollTop() - Component.offset().top) / divisor;

			bg.height(bgHeight);
			bg.css({ marginTop: bgTop });
		}

	}

	$.fn.ZagParallax = (function (options) {
		return this.each(function () {
			(new $.ZagParallax($(this), options));
		});
	});

	$.ZagParallax.defaultOptions = { divisor: 1 };

	//
	// Midground pattern parallax: arrows and plus pattern
	//
	$.MidgroundParallax = function (element, options) {

		options = $.extend({}, $.MidgroundParallax.defaultOptions, options);

		var Component = element;

		Component.addClass("midground-parallax");
		MidgroundParallaxSet(Component, options.downDivisor, options.rightDivisor);

		$(window).on("resize scroll", function () {
			MidgroundParallaxSet(Component, options.downDivisor, options.rightDivisor);
		});
	};

	function MidgroundParallaxSet(Component, downDivisor, rightDivisor) {
		var windowHeight = $(window).innerHeight();
		var componentTop = Component[0].getBoundingClientRect().top;
		var componentBottom = Component[0].getBoundingClientRect().top + Component[0].offsetHeight;

		if (componentTop != componentBottom && componentTop <= windowHeight && componentBottom >= 0) { //if component is visible and on screen

			var bgY = ($(window).scrollTop() - Component.offset().top) / downDivisor;
			var bgX = ($(window).scrollTop() - Component.offset().top) / rightDivisor;

			Component.css({ "background-position-y": bgY });
			Component.css({ "background-position-x": bgX });
		}
	}

	$.fn.MidgroundParallax = (function (options) {
		return this.each(function () {
			(new $.MidgroundParallax($(this), options));
		});
	});

	$.MidgroundParallax.defaultOptions = { downDivisor: 0, rightDivisor: 0 };

})(jQuery);